'use strict';

// Banner click tracking: elements with data-pippei-track="<id>" publish the Shopify customer event "pippei_banner_click"
// (event_name "<id>_click", banner_name, placement, destination). A custom pixel in Shopify admin (Settings > Customer
// events) forwards it to Google Analytics; GA runs in Shopify's pixel sandbox, so window.gtag does not exist on the page.
// Where a page does have gtag (a tag installed in the theme), the event goes there instead.
document.addEventListener('click', function (ev) {
  var el = ev.target.closest ? ev.target.closest('[data-pippei-track]') : null;
  if (!el) return;
  var id = el.getAttribute('data-pippei-track');
  var data = {
    event_name: id + '_click',
    banner_name: id,
    placement: window.location.pathname,
    destination: el.getAttribute('href') || ''
  };
  try {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (analytics && typeof analytics.publish === 'function') {
      analytics.publish('pippei_banner_click', data);
    } else if (typeof window.gtag === 'function') {
      window.gtag('event', data.event_name, { placement: data.placement, banner_name: data.banner_name, destination: data.destination });
    }
  } catch (e) { /* tracking must never break a click */ }
});
